import { render, staticRenderFns } from "./LanguageAvailable.vue?vue&type=template&id=5a3bca89&"
import script from "./LanguageAvailable.vue?vue&type=script&lang=js&"
export * from "./LanguageAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports